export default "__VITE_ASSET__BHoZRC8V__"